/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { QuestionLibraryItemRepositoryResponse } from "../types/QuestionLibraryItemRepositoryResponse.ts";

export const questionLibraryItemRepositoryResponseSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID da questão no banco de questões."),
  ),
  label: z
    .string()
    .describe("Enunciado da questão (pode conter HTML). Opcional.")
    .nullish(),
  componentType: z
    .string()
    .describe(
      "Descrição textual do tipo de componente da questão (ex: SingleChoice, MultilineText). Opcional.",
    )
    .nullish(),
  status: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status de aprovação da questão no banco de questões. Enum EExamItemStatus: `1` = Pending, `2` = Approved, `3` = Rejected.",
      ),
  ),
  statusText: z
    .string()
    .describe("Descrição textual do status de aprovação da questão. Opcional.")
    .nullish(),
  personAuthorName: z
    .string()
    .describe("Nome do autor da questão. Opcional.")
    .nullish(),
  isOwner: z.optional(
    z
      .boolean()
      .describe("Indica se o usuário autenticado é o autor/dono da questão."),
  ),
  disciplineName: z
    .string()
    .describe("Nome da disciplina associada à questão. Opcional.")
    .nullish(),
  cultureInfo: z
    .string()
    .describe(
      "Código de cultura do idioma da questão (ex: pt-BR, en-US). Opcional.",
    )
    .nullish(),
  active: z.optional(
    z
      .boolean()
      .describe("Indica se a questão está ativa no banco de questões."),
  ),
}) as unknown as ToZod<QuestionLibraryItemRepositoryResponse>;
